import { differenceInCalendarDays, format } from 'date-fns'

import { DATE_HOURS_FORMAT } from '../../../constants/date'
import { toUkTimezoneDate } from '../../../utils/date'

function getBirdviewDeadlineInfo({ deadline, now, timeZone }) {
  const deadlineDate = toUkTimezoneDate(deadline, timeZone)
  const days = differenceInCalendarDays(now, deadlineDate)

  if (days > 0) {
    return { count: days, key: 'DashboardBirdview.DeadlineOverdueKey' }
  }

  if (days === 0) {
    return {
      key: 'DashboardBirdview.DeadlineDueAtKey',
      time: format(deadlineDate, DATE_HOURS_FORMAT),
    }
  }

  return { count: -days, key: 'DashboardBirdview.DeadlineDueInKey' }
}

// A flag reason ("no provider", "stale 3d") replaces the deadline when set.
export function getBirdviewRowDeadlineText({
  deadline,
  hint,
  now,
  t,
  timeZone,
}) {
  if (hint) {
    return hint
  }

  if (!deadline) {
    return null
  }

  const info = getBirdviewDeadlineInfo({ deadline, now, timeZone })

  return t(info.key, { count: info.count, time: info.time })
}
